// extracted by mini-css-extract-plugin
export default {"background":"App_background__IxVd3","content_wrap":"App_content_wrap__ytqtz"};